export const tedeeConfig = {
  common: {
    saving: "Salvataggio...",
    connected: "Connesso",
    disconnected: "Disconnesso",
    lockFallbackNamed: "Serratura {id}",
    deviceFallbackNamed: "Dispositivo Tedee {id}",
    unitFallback: "Unità",
    unitFallbackNamed: "Unità {id}",
  },

  credentials: {
    title: "Configurazione Tedee",
    apiVersionInUse: "Versione API in uso:",
    savedKey: "Chiave salvata",
    noKey: "Nessuna chiave",
    keyLabel: "Chiave di accesso personale",
    keyPlaceholderSaved: "•••••••• (salvata, modifica facoltativa)",
    keyPlaceholderNew: "Inserisci la tua Chiave di accesso personale Tedee",
    keyHintSaved: "Puoi lasciarlo vuoto se hai già una chiave salvata.",
    keyHintNew: "Ottieni la tua chiave dal portale Tedee.",
    testing: "Verifica in corso...",
    test: "Verifica connessione",
    save: "Salva credenziali",
  },

  selector: {
    title: "Selettore serrature per questa struttura",
    subA: "Seleziona solo le serrature che riguardano",
    subBold: "questa struttura",
    subB: ". Nel PMS vedrai poi solo quelle selezionate.",
    selectedCount: "{count} selezionate",
    hintNoKeyA: "Inserisci la tua Chiave di accesso personale e premi",
    hintNoKeyBold: "Verifica connessione",
    hintNoKeyB: "per caricare le tue serrature.",
    emptyDevices:
      "Non abbiamo trovato nessuna serratura o cancello nel tuo account Tedee. Assicurati che il dispositivo sia registrato e condiviso con l'account di cui hai salvato la chiave sopra.",
    placeholder: "Seleziona serrature…",
    summaryCount: "{count} serratura/e selezionate",
    summaryEmpty: "Nessuna serratura selezionata",
    save: "Salva serrature per questa struttura",
  },

  pms: {
    title: "Controllo e assegnazione (PMS)",
    subA:
      "Qui compaiono solo le serrature che hai salvato per questa struttura. Assegna ciascuna a",
    subBold1: "Porta principale",
    subOr: "o",
    subBold2: "Unità",
    subEnd: ".",
    assignedCount: "{count} assegnate",
    empty: {
      A: "Non hai ancora nessuna serratura salvata per questa struttura. Usa il",
      bold: "selettore",
      B: "qui sopra e poi salva.",
    },
    assignmentLabel: "Assegnazione",
    assignmentNone: "Non assegnata",
    assignmentGate: "Porta principale (Cancello)",
    assignmentCommon: "Porta principale (condivisa)",
    assignmentUnit: "Porta dell'appartamento",
    hintNone: "Non sarà controllata dal PMS.",
    hintGate: "Cancello: può essere premuto solo per aprire (nessun supporto per blocco/PIN).",
    hintUnit: "Sarà collegata a questa struttura per controllo/PIN.",
    unitLabel: "Unità / Alloggio",
    unitSelect: "Seleziona un'unità",
    unitHint: "Seleziona quale unità apre questa serratura.",
    nameLabel: "Nome (facoltativo)",
    namePlaceholder: "Es. Porta principale / App. 101",
    nameHint: "Questo nome viene salvato quando salvi di nuovo il selettore delle serrature.",
    actions: {
      lock: "Blocca",
      unlock: "Sblocca",
      createPin: "Crea PIN",
      pinHistory: "Cronologia PIN",
      openGate: "Apri cancello (impulso)",
      refresh: "Aggiorna stato",
    },
    save: "Salva assegnazione",
    tipA: "Suggerimento: assegna una porta principale o un'unità e premi",
    tipBold: "Salva assegnazione",
    tipB: ". I pulsanti si attivano una volta assegnato il dispositivo.",
  },

  pinHistory: {
    title: "Cronologia PIN",
    loading: "Caricamento cronologia…",
    empty: "Nessun PIN registrato per questa serratura.",
    colAlias: "Alias",
    colPin: "PIN",
    colValidity: "Validità",
    colState: "Stato",
    createdPrefix: "Creato:",
    fromLabel: "Da:",
    toLabel: "A:",
    revokeTitle: "Elimina / Revoca PIN",
    noteA: '* "Attivo" viene calcolato confrontando la data/ora attuale con',
    noteMid: "e",
    noteEnd: ".",
    close: "Chiudi",
  },

  pinModal: {
    title: "Crea PIN",
    nameLabel: "Nome / Etichetta",
    namePlaceholder: "Es. Pulizie / Ospite / Tecnico",
    pinLabel: "PIN",
    pinPlaceholder: "6 cifre",
    generateTitle: "Genera",
    pinHint: "Se lo lasci vuoto, il backend ne genera uno.",
    modeLabel: "Modalità",
    modeTimeLimited: "Con date",
    modeOngoing: "Senza date (fino alla revoca)",
    validFrom: "Valido dal",
    validTo: "Valido al",
    tipLabel: "Suggerimento:",
    tipText: "Per un ospite, usa un PIN con date di check-in/check-out.",
    cancel: "Annulla",
    creating: "Creazione...",
    create: "Crea PIN",
  },

  toast: {
    noLocksFound: "Nessuna serratura (tipo 2/5) trovata in Tedee.",
    loadStatusError: "Impossibile caricare lo stato della serratura",
    loadStatusError2: "Errore durante il caricamento dello stato della serratura",
    needKey: "Devi inserire una Chiave di accesso personale o avere una chiave salvata.",
    connectionOk: "Connessione riuscita. {count} dispositivo/i trovato/i.",
    testError: "Errore durante la verifica della connessione",
    needValidKey:
      "Devi inserire una Chiave di accesso personale valida (almeno 10 caratteri).",
    credentialsSaved: "Credenziali salvate con successo",
    saveCredentialsError: "Errore durante il salvataggio delle credenziali",
    saveCredentialsErrorPrefix: "Errore durante il salvataggio delle credenziali: ",
    needOneDevice: "Devi selezionare almeno un dispositivo per questa struttura.",
    devicesSaved: "Dispositivi salvati per questa struttura",
    devicesSaveError: "Impossibile salvare i dispositivi",
    saveErrorPrefix: "Errore durante il salvataggio: ",
    gateNoLock:
      "Il cancello (tipo 5) non supporta il blocco. Può essere premuto solo per aprire.",
    locked: "Serratura bloccata",
    lockError: "Impossibile bloccare",
    lockError2: "Errore durante il blocco",
    gateOpened: "Cancello aperto (impulso)",
    unlocked: "Serratura sbloccata",
    unlockError: "Impossibile sbloccare",
    unlockError2: "Errore durante lo sblocco",
    needUnitForApartment:
      "Seleziona l'unità per le serrature assegnate come 'Porta dell'appartamento'.",
    bindingsSaved: "Assegnazione salvata con successo",
    bindingsSaveError: "Impossibile salvare l'assegnazione",
    bindingsSaveErrorPrefix: "Errore durante il salvataggio dell'assegnazione: ",
    gateNoPin: "Il cancello (tipo 5) non supporta i PIN.",
    assignFirst:
      "Assegna prima la serratura (porta principale o unità) e salva per abilitare il controllo.",
    needPinName: "Devi fornire un nome/etichetta per il PIN.",
    needValidDates: "Devi fornire una data di inizio e di fine validità.",
    pinCreated: "PIN creato con successo",
    pinCreateError: "Impossibile creare il PIN",
    pinCreateError2: "Errore durante la creazione del PIN",
    gateNoPinHistory: "Il cancello (tipo 5) non supporta la cronologia PIN.",
    historyLoadError: "Impossibile caricare la cronologia",
    historyLoadError2: "Errore durante il caricamento della cronologia",
    noProviderPinId:
      "Questo PIN non ha provider_pin_id. Non può essere revocato in Tedee.",
    pinRevoked: "PIN revocato",
    revokeError: "Impossibile revocare",
    revokeError2: "Errore durante la revoca del PIN",
  },

  confirm: {
    revokePin: 'Sei sicuro di voler revocare/eliminare il PIN "{alias}"?',
  },

  pinState: {
    active: "Attivo",
    upcoming: "Futuro",
    expired: "Scaduto",
    revoked: "Revocato",
    none: "Senza date",
  },
};
